<div class="pool-config-transactions-container p-6">

    <!-- Header -->
    <div class="flex items-center justify-between mb-6">
        <div class="flex items-center gap-4">
            <button type="button" (click)="goBack()"
                class="inline-flex items-center px-3 py-2 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50">
                <svg class="h-4 w-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
                </svg>
                Back to Config
            </button>
            <div>
                <h1 class="text-2xl font-semibold text-gray-900">Pool Transactions</h1>
                <p class="text-sm text-gray-500 mt-1">
                    Parking processes for config <span class="font-mono text-xs">{{ configId() }}</span>
                </p>
            </div>
        </div>
    </div>

    <!-- Filter -->
    <jjames-card class="mb-6">
        <div class="px-6 py-4">
            <form [formGroup]="filterForm" class="flex flex-wrap items-end gap-4">
                <div>
                    <label class="block text-sm font-medium text-gray-700 mb-1">From</label>
                    <input type="date" formControlName="from"
                        class="px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500">
                </div>
                <div>
                    <label class="block text-sm font-medium text-gray-700 mb-1">To</label>
                    <input type="date" formControlName="to"
                        class="px-3 py-2 border border-gray-300 rounded-md text-sm focus:outline-none focus:ring-2 focus:ring-indigo-500">
                </div>
                <jjames-button variant="primary" (clicked)="applyFilter()" [disabled]="loading()">
                    Apply
                </jjames-button>
            </form>
        </div>
    </jjames-card>

    <!-- Error -->
    @if (errorMessage()) {
    <div class="mb-4">
        <jjames-alert type="error" [dismissible]="true" (dismissed)="errorMessage.set(null)">
            {{ errorMessage() }}
        </jjames-alert>
    </div>
    }

    <!-- Loading -->
    @if (loading()) {
    <div class="flex justify-center items-center py-12">
        <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-indigo-600"></div>
    </div>
    }

    <!-- Table -->
    @if (!loading()) {
    <jjames-card>
        <div class="px-6 py-4 border-b border-gray-200">
            <h2 class="text-lg font-medium text-gray-900">
                Transactions
                <span class="ml-2 text-sm font-normal text-gray-500">({{ totalCount() }} total)</span>
            </h2>
        </div>
        <jjames-table [columns]="columns" [data]="getTableData()"
            emptyMessage="No transactions found for this date range.">
        </jjames-table>
        @if (totalCount() > pageSize()) {
        <div class="px-6 py-4 border-t border-gray-200">
            <jjames-paginator [config]="paginationConfig" (pageChange)="onPageChange($event)">
            </jjames-paginator>
        </div>
        }
    </jjames-card>
    }
</div>